import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RootRedirectHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectPath = localStorage.getItem("publicRedirect");
    if (redirectPath) {
      localStorage.removeItem("publicRedirect"); // Clear it to avoid unwanted redirects
      navigate(redirectPath, { replace: true });
    }
  }, [navigate]);

  return null; // This component doesn't render anything
};

export default RootRedirectHandler;
